import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import {CssBaseline, ThemeProvider} from '@mui/material'
import {theme} from './common/assets/theme'
import {Provider} from 'react-redux'
import {store} from './common/store/store'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<App />
			</ThemeProvider>
		</Provider>
	</React.StrictMode>
)